import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiNotepad } from 'react-icons/pi';
import { ILabelForm } from 'services/labels/types';

const LabelRemarks = () => {
  const {
    values,
    status,
  }: IFormikContextType<ILabelForm> =
    useFormikContext<ILabelForm>();
  const { t } = useTranslation();
  return (
    <Container className=' self-start max-w-[500px]'>
      <Container.Header
        title={
          <>
            <PiNotepad /> {t('label.remarks.header')}
          </>
        }
      />
      <Container.Content>
        {status?.displayMode ? (
          values.notes?.trim().length ? (
            values.notes
          ) : (
            t('label.remarks.no-remarks')
          )
        ) : (
          <FormInput.Field name='notes' label={t('input.label.remarks')} />
        )}
      </Container.Content>
    </Container>
  );
};

export default LabelRemarks;
